<template>
  <div class="todo">
    <div class="todo-nav" v-if="tabValue != 0">
      <div
        class="todo-nav-item"
        v-for="(item, index) in tabs"
        :key="index"
        :class="{ active: item.value == tabValue }"
        @click="tabChange(item.value)"
      >
        <Badge :count="item.count"
          ><span class="text">{{ item.label }}</span></Badge
        >
      </div>
    </div>
    <div class="toto-body">
      <empty
        v-if="tabValue == 0"
        class="tip"
        text="页面需要授权才能访问"
      ></empty>
      <drugMutualTesting v-if="tabValue == 1" />
      <patientFeedback v-else-if="tabValue == 2" />
      <textualReview v-else-if="tabValue == 3" />
      <medicalConsultation v-else-if="tabValue == 4" />
    </div>
  </div>
</template>

<script>
import { hasAuth } from "@/utils/uEdition.js";
import drugMutualTesting from "./drugMutualTesting/index.vue";
import patientFeedback from "./patientFeedback/index.vue";
import textualReview from "./textualReview/index.vue";
import medicalConsultation from "./medicalConsultation/index.vue";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["todoNumber"]),
  },
  components: {
    drugMutualTesting,
    patientFeedback,
    textualReview,
    medicalConsultation,
  },
  data() {
    return {
      tabValue: 1,
      tabs: [],
    };
  },
  watch: {
    todoNumber(newValue, oldValue) {
      this.setTabs();
    },
  },
  methods: {
    setTabs() {
      this.tabs = [];
      if (hasAuth("YZ-15")) {
        this.tabs.push({
          label: "用药互检",
          value: 1,
          count: this.todoNumber.medicationExaminationNum,
        });
      }
      if (hasAuth("YZ-12")) {
        this.tabs.push({
          label: "线上提问",
          value: 2,
          count: this.todoNumber.feedbackNum,
        });
      }
      if (hasAuth("YZ-18")) {
        this.tabs.push({
          label: "话术检视",
          value: 3,
          count: this.todoNumber.doctorCheckNum,
        });
      }

      if (hasAuth("YZ-26")) {
        this.tabs.push({
          label: "医术咨询",
          value: 4,
          count: this.todoNumber.medicalExpertiseDot.allNum,
        });
      }
    },
    setTabValue() {
      if (!hasAuth("YZ-17") || this.tabs.length < 0) {
        this.tabValue = 0;
      } else {
        this.tabValue = this.tabs[0].value;
      }
    },
    tabChange(val) {
      this.tabValue = val;
    },
  },
  created() {
    this.setTabs();
    this.setTabValue();
  },
};
</script>

<style lang="scss" scoped>
.todo {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #fff;
  .todo-nav {
    flex-shrink: 0;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #853a2f22;
    .todo-nav-item {
      margin: 0 20px;
      color: #000;
      border-radius: 15px;
      cursor: pointer;
      &.active {
        background: #fff;
      }
      .text {
        padding: 0 10px;
      }
    }
  }
  .toto-body {
    height: 1000%;
    overflow: hidden;
  }
  :deep {
    .successCase {
      padding: 0;
    }
  }
}
</style>